<script lang="ts">
	import { format } from 'svelte-i18n';
	import { BulletedList, Text } from '@Shelly/shelly-design-system/index';
	import TemplateInputSettings from './Components/TemplateInputSettings.svelte';
	import TemplateToggleSettings from './Components/TemplateToggleSettings.svelte';
	import TemplateDropdownSettings from './Components/TemplateDropdownSettings.svelte';
	import type { Device } from 'src/types/Device';
	import type { XT1DeviceSettings } from 'src/helpers/xt1_helpers/template_settings_helpers';

	export let device: Device;
	export let setting: XT1DeviceSettings;
</script>

{#if setting.key}
	{#if setting.desc}
		{#if Array.isArray(setting.desc)}
			<BulletedList
				titleClasses="text-normal"
				titleStyleType="body-extra-small"
				class="mb-s"
				list={setting.desc}
			/>
		{:else}
			<Text class="mb-s" styleType="body-small" size="s" slot="description">
				{$format(`label_${setting.key.toLowerCase()}_desc`, {
					default: setting.desc,
				})}
			</Text>
		{/if}
	{/if}

	{#if setting.type === 'boolean'}
		<TemplateToggleSettings
			{device}
			setting={setting.key}
			title={$format('enable', {
				default: 'Enable',
			})}
		/>
	{:else if setting.type === 'number'}
		<TemplateInputSettings
			{device}
			setting={setting.key}
			min={setting.range?.min ?? 0}
			max={setting.range?.max ?? 100}
			withCheckbox
		/>
	{:else if Array.isArray(setting.options)}
		<TemplateDropdownSettings {device} setting={setting.key} options={setting.options} />
	{/if}
{/if}
